import { Action } from '@ngrx/store';

import { Group } from '../../shared/models/groups/groups.model';
import { WijmoSortEvent } from '../../../../shared/models/wijmo-sort-event';
import { CustomerTab } from '../../../xena-tabs/shared/models/customer-tab.model';



export const SELECT_REGION = '[XENA] SELECT_REGION';
export const SELECT_GROUP = '[XENA] SELECT_GROUP';
export const SELECT_OFFER = '[XENA] SELECT_OFFER';
export const GROUP_OFFERS_BY = '[XENA] GROUP_OFFERS_BY';
export const SORT_OFFERS_BY = '[XENA] SORT_OFFERS_BY';
export const SORT_GROUPS_BY = '[XENA] SORT_GROUPS_BY';
export const INIT_SELECTION_TABS = '[XENA] INIT_SELECTION_TABS';



export class SelectRegion implements Action {
	readonly type = SELECT_REGION;

	constructor(public payload: Array<string>) {}
}

export class SelectGroup implements Action {
	readonly type = SELECT_GROUP;

	constructor(public payload: Array<Group>) {}
}

export class SelectOffer implements Action {
	readonly type = SELECT_OFFER;

	constructor(public payload: Group) {}
}

export class GroupOffersBy implements Action {
	readonly type = GROUP_OFFERS_BY;

	constructor(public payload: Array<string>) {}
}

export class SortOffersBy implements Action {
	readonly type = SORT_OFFERS_BY;

	constructor(public payload: WijmoSortEvent) {}
}

export class SortGroupsBy implements Action {
	readonly type = SORT_GROUPS_BY;

	constructor(public payload: WijmoSortEvent) {}
}

export class InitSelectionTabs implements Action {
	readonly type = INIT_SELECTION_TABS;

	constructor(public payload: Array<CustomerTab>) {}
}



export type All
	= SelectRegion
	| SelectOffer
	| SelectGroup
	| GroupOffersBy
	| SortOffersBy
	| SortGroupsBy
	| InitSelectionTabs;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/selection.ts